export const MODULES = [
  ['portal_configuracoes', 'Portal: publicações e seleções'],
  ['portal_inscricoes', 'Portal: inscrições'],
  ['portal_documentos', 'Portal: documentos'],
  ['portal_recursos', 'Portal: recursos'],
  ['portal_relatorios', 'Portal: relatórios'],
  ['portal_integracoes', 'Portal: integrações'],
  ['disciplinas_questoes', 'Disciplinas/Questões'],
  ['processo_seletivo', 'Processo Seletivo'],
  ['dashboard_resultados', 'Dashboard de Resultados'],
  ['provas', 'Provas'],
  ['redacoes', 'Redações'],
  ['questionarios', 'Questionários'],
  ['banca_questoes', 'Banca de Questões'],
  ['candidatos', 'Candidatos'],
  ['fiscais', 'Fiscais'],
  ['avaliadores', 'Avaliadores'],
  ['entrevistas', 'Entrevistas'],
  ['corretores', 'Corretores'],
];

export const PROCESS_MODULES = ['dashboard_resultados', 'provas', 'redacoes', 'candidatos', 'fiscais', 'avaliadores', 'entrevistas', 'corretores'];
export const VIEW_ONLY_MODULES = ['dashboard_resultados'];
export const ACTIONS = [['view', 'Ver'], ['create', 'Adicionar'], ['edit', 'Editar'], ['delete', 'Excluir']];

export const can = (user, module, action = 'view') => {
  if (!user || user.role === 'region_admin' || user.empresa?.owner_id === user.id) return true;
  const permissions = user.module_permissions;
  if (!permissions || Object.keys(permissions).length === 0) return true;
  return !!permissions[module]?.[action] &&
    (!PROCESS_MODULES.includes(module) || !!permissions.processo_seletivo?.view);
};

export const canSeeRooms = user => ['candidatos', 'fiscais', 'corretores'].some(module => can(user, module));

export const canManageMembers = user => !!user && user.empresa?.owner_id === user.id;

export const unrestricted = user => !user || user.role === 'region_admin' ||
  user.empresa?.owner_id === user.id ||
  !user.module_permissions || Object.keys(user.module_permissions).length === 0;

export const emptyPermissions = () => Object.fromEntries(MODULES.map(([key]) => [key, {
  view: false, create: false, edit: false, delete: false,
}]));
